export default {
    "Pricing.index.525610-0": "定价",
    "Pricing.index.525610-1": "AppKit Landing 的未来更新对现有客户完全免费",
    "Pricing.index.525610-2": "免费",
    "Pricing.index.525610-3": "（需注明出处）",
    "Pricing.index.525610-4": "单次安装",
    "Pricing.index.525610-5": "多处安装",
    "Pricing.index.525610-6": "无需注明出处即可使用链接",
    "Pricing.index.525610-7": "单应用程序",
    "Pricing.index.525610-8": "（商业许可）",
    "Pricing.index.525610-9": "多应用",
    "Pricing.index.525610-10": "许可证详情",
}